import styles from './styles/component.flat-preview.module.scss';
import { getSrcSetForLazy } from '../utils/getSrcSetForLazy';
import { debounce } from '../js/debounce';
const vn = window.vNode;
const cache = new Map();
const preloadImage = ({ src, srcSet, sizes, onLoad }) => {
    const key = `${srcSet ?? src} - ${sizes}`;
    const state = cache.get(key);
    if (state === true) {
        return true;
    }
    else if (state === undefined) {
        cache.set(key, [onLoad]);
        const img = new window.Image();
        img.onerror = img.onload = () => {
            const onLoads = cache.get(key);
            cache.set(key, true);
            typeof onLoads === 'object' && onLoads.forEach(fun => { fun(); });
        };
        if (srcSet !== undefined) {
            img.sizes = sizes;
            img.srcset = srcSet;
        }
        else {
            img.src = src;
        }
    }
    else {
        cache.set(key, [
            ...state,
            onLoad
        ]);
    }
    return false;
};
const loader = () => (vn.create('span', { class: 'pos:a z:4 t:0 l:0 r:0 b:0 lh:0' }, vn.create('span', { class: 'pos:a t:50p l:50p trf:t:-50p' }, vn.create('i', { class: 'd:block icon--loader fz:36' }))));
if (window.customElements.get('flat-preview-component') === undefined) {
    window.customElements.define('flat-preview-component', class FlatPreview extends HTMLElement {
        data;
        _isDelayed = true;
        _delayTimeout = 0;
        _srcSetMaxSize;
        _alt;
        _vNodes = [];
        constructor() {
            super();
            this.render = this.render.bind(this);
        }
        get _data() {
            return this.data;
        }
        set _data(data) {
            if (data === undefined)
                return;
            for (const key of Object.keys(data)) {
                if (data[key] !== this.data?.[key]) {
                    this.data = data;
                    this.render();
                    break;
                }
            }
        }
        render() {
            if (this.data === undefined)
                return;
            const { width, thickness, art, room, x, y, layout, style, color } = this.data;
            const containerWidth = this.offsetWidth;
            const widthCoefficient = (width - thickness * 2) / 100;
            const frameWidth = Math.round(containerWidth * (thickness / 100));
            const srcSet = getSrcSetForLazy(art, this._srcSetMaxSize !== undefined ? Math.round(this._srcSetMaxSize * widthCoefficient) : undefined);
            const sizes = `${containerWidth * widthCoefficient}px`;
            let bgLoaded = room === null;
            const artLoaded = preloadImage({
                src: art,
                srcSet,
                sizes,
                onLoad: this.render
            });
            const newVNodes = [];
            if (room !== null) {
                const bgSrcSizes = getSrcSetForLazy(room, this._srcSetMaxSize);
                const bgSizes = `${containerWidth}px`;
                bgLoaded = preloadImage({
                    src: room,
                    srcSet: bgSrcSizes,
                    sizes: bgSizes,
                    onLoad: this.render
                });
                if (bgLoaded) {
                    newVNodes.push(vn.create('img', {
                        class: 'pos:a t:0 l:0 image:cover',
                        sizes: bgSizes,
                        srcSet: bgSrcSizes,
                        src: room,
                        alt: this._alt ?? '',
                        height: 1200,
                        width: 1200
                    }));
                }
            }
            if (bgLoaded && artLoaded) {
                window.clearTimeout(this._delayTimeout);
                this._delayTimeout = 0;
                this._isDelayed = false;
                newVNodes.push(vn.create('span', {
                    class: 'pos:a trf:t:-50p50p z:2 lh:0',
                    style: `width: ${width - thickness * 2}%;
                left: ${x}%; bottom: ${y}%;`
                }, [
                    vn.create('img', {
                        class: 'image:cover bg:f4f4f4 pos:r',
                        sizes,
                        srcSet,
                        src: art,
                        alt: ''
                    }),
                    vn.create('span', {
                        class: `pos:a z:2 bd bxsh:3 trf:tz:1px ${styles[`${layout}-${style}-${color}`]}`,
                        style: `border-width: ${frameWidth}px;
                    border-image-width: ${frameWidth}px;
                    left: -${frameWidth - 1}px;
                    top: -${frameWidth - 1}px;
                    height: calc(100% + ${frameWidth * 2 - 2}px);
                    width: calc(100% + ${frameWidth * 2 - 2}px);`
                    })
                ]));
            }
            else {
                if (!this._isDelayed) {
                    this._delayTimeout = window.setTimeout(() => {
                        this._delayTimeout = 0;
                        this.render();
                    }, 99);
                    this._isDelayed = true;
                }
                if (this._delayTimeout > 0) {
                    return;
                }
                newVNodes.push(loader());
            }
            vn.patch(this._vNodes, newVNodes, this);
            this._vNodes = newVNodes;
        }
        connectedCallback() {
            const json = this.querySelector('script')?.textContent;
            if (json !== null && json !== undefined) {
                this.data = JSON.parse(json);
            }
            this.classList.add(styles.preloadBorders);
            this.render();
            const debouncedRender = debounce(this.render);
            window.addEventListener('resize', debouncedRender);
        }
    });
}
